var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toaster',{staticClass:"text-copied-toaster",on:{"close-toaster":_vm.closeTextCopiedToaster},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('div',[_c('span',[_vm._v(" מעולה! הלינק הועתק בהצלחה")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }